import { FormikErrors, FormikTouched, useFormikContext } from "formik";
import {
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Button, Modal, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { RowMouseEventHandlerParams } from "react-virtualized";
import { useDebounce } from "../../../../../_metronic/helpers";
import { KEY_LOCALSTORAGE } from "../../../auth/core/_consts";
import { ConfirmDialog } from "../../../component/ConfirmDialog";
import { IconBack, IconButtonSave, IconMenu } from "../../../component/IconSvg";
import InputSearch from "../../../component/InputSearch";
import LabelRequired from "../../../component/LabelRequired";
import SelectTree from "../../../component/SelectTree";
import TextField from "../../../component/TextField";
import DatePickerCustom from "../../../component/date-picker/DatePickerCustom";
import SimpleTable from "../../../component/table/simple-table/SimpleTable";
import { TableCustom } from "../../../component/table/table-custom/TableCustom";
import { CODE_DOI_TUONG } from "../../../phan-he-tiep-nhan-thanh-toan/constants/PhanHeTiepNhan";
import PaymentInfor from "../../../phan-he-vien-phi/components/PaymentInfor";
import { handleSearchByFuse } from "../../../utils/AppFunction";
import {
  CODE,
  KEY_DS_DANH_MUC_TIEP_DON,
  OBS_COMPLEX_CATEGORY_CODE,
  ORDER_TYPE_ID,
  SELECTION_MODE,
  SIMPLE_CATEGORY_TYPE,
  TERM_CLASS_IDS,
  WORKFLOW_ORG_CONFIG_CODE
} from "../../../utils/Constant";
import { formatMoney } from "../../../utils/FormatUtils";
import { getIndexedDBItem } from "../../../utils/IndexedDB";
import { localStorageItem } from "../../../utils/LocalStorage";
import { getObsComplexCategory, getSimpleCategory, getTermClasses } from "../../../utils/ServicesUtils";
import ICD10 from "../../components/ICD10";
import InfoPatientRight from "../../components/InfoPatientRight";
import ProvisonalDiagnosis from "../../components/ProvisonalDiagnosis";
import { TreeChiDinhDichVu } from "../../constants/KhamBenh";
import { PhanHeTiepDonContext } from "../../contexts/PhanHeTiepDonContext";
import { IDonThuocMauRequest } from "../../models/ThuocModels";
import { getThongTinPhieuChiDinh } from "../../services/ChiDinhDVService";
import { BASE_URL, getThongTinChanDoan } from "../../services/KhamBenhService";
import { ServiceTemplateButton } from "../../components/service-template-button";
import {
  DsDichVuChiDinhColumn,
  dsDichVuColumnsSimple,
} from "./ChiDinhDichVuColumn";
import useWorkflowOrgConfig from "../../../../hook/useWorkflowOrgConfig";
import { CONTEXT_MENU_CODE, SERVICE_CONTEXT_MENU_OPTIONS, TERMS_CLASS_ID_DICH_VU } from "../../constants/ChiDinhDVConst";
import moment from "moment";
import { OctContextMenu } from "@oceantech/oceantech-ui";
import { GenerateFormModal } from '../../../component/generate-form-modal';
import { ServiceSplitHelper, SplitServiceItem, MergedServiceRow } from '../../utils/ServiceSplitHelper';
import { SplitItemsModal } from './components/SplitItemsModal';

interface Props {
  handleClose: Dispatch<SetStateAction<boolean>>;
  dieuTri?: boolean;
  orderGroupId?: string;
  isSaveAndPrint: React.MutableRefObject<boolean>
  generalInfo?: any
}

const FormChiDinhDichVu: FC<Props> = (props) => {
  let { handleClose, orderGroupId, isSaveAndPrint, generalInfo = {} } = props;
  const isSuaPhieu = orderGroupId ? true : false;
  let { values, setFieldValue, setValues, errors, touched } = useFormikContext<any>();
  let currentUser = localStorageItem.get(KEY_LOCALSTORAGE.CURRENT_USER);
  const { benhNhanInfo } = useContext(PhanHeTiepDonContext);
  let { visit, orderId, encounterDiagnosis, isExamined } = benhNhanInfo?.thongTinKhamBenh || generalInfo;
  const { config: paymentConfig } = useWorkflowOrgConfig({
		code: WORKFLOW_ORG_CONFIG_CODE.FORM_INFO_PAYMENT_ASSIGN
	});
  // ENABLE_AUTO_SPLIT_SERVICE - Hardcoded to true (instead of using workflow config)
  const autoSplitEnabled = true;

//   const { config: autoSplitEnabled } = useWorkflowOrgConfig({
// 		code: WORKFLOW_ORG_CONFIG_CODE.ENABLE_AUTO_SPLIT_SERVICE
// 	});

  const [selectedRowIndex, setSelectedRowIndex] = useState<number | null>(null);
  const [codeCollapses, setCodeCollapses] = useState<string[]>([]);
  const [idSelected, setIdSelected] = useState<string>("");
  const [shouldOpenConfirmDialog, setShouldOpenConfirmDialog] =
    useState<boolean>(false);
  const [shouldOpenModalICD10, setShouldOpenModalICD10] =
    useState<boolean>(false);
  const [treeData, setTreeData] = useState<any>(TreeChiDinhDichVu);
  const [listDichVu, setListDichVu] = useState<any[]>([]);
  const [listDichVuSearch, setListDichVuSearch] = useState<any[]>([]);
  const [listICD10, setListICD10] = useState<any>([]);
  const [expenseObject, setExpenseObject] = useState({
    tong: '0',
    benhNhan: '0',
    conNo: '0',
    conDu: '0',
  }) 
  const [textSearch, setTextSearch] = useState<string>("");
  const [selectedRow, setSelectedRow] = useState<any[]>([]);
  const [listResponseService, setListResponseService] = useState<any>([]);
  const [listComorbidity, setListComorbidity] = useState<any[]>([]);
  const [shouldOpenModalSelectICD10, setShouldOpenModalSelectICD10] = useState<boolean>(false);
  const [paymentItem, setPaymentItem] = useState<any>([]);
  const [contextMenu, setContextMenu] = useState<null | {
    x: number;
    y: number;
  }>(null);
  const [openAdditionalInfoModal, setOpenAdditionalInfoModal] = useState(false);
  const [showSplitModal, setShowSplitModal] = useState(false);
  const [selectedMergedRow, setSelectedMergedRow] = useState<MergedServiceRow | null>(null);

  const categoriesRef = useRef<{
    configPriceObject: any[];
    objectTypes: any[];
  }>({
    configPriceObject: [],
    objectTypes: [],
  });
  const rowEditRef = useRef<any>(null);

  const displayOrders = useMemo(() => {
    console.log('displayOrders:', {
      ordersCount: values?.orders?.length,
      sample: values?.orders?.[0],
    });
    return values?.orders || [];
  }, [values?.orders]);

  const { BAO_HIEM, VIEN_PHI } = CODE_DOI_TUONG;
  const typeObjectCode = visit?.visitObjectTypeCode;
  const thongTinChiPhi = {
    tongChiPhi: visit.ttTong,
    bhyt: visit.ttBhyt,
    benhNhan: visit.ttNguoiBenh,
    tamUng: visit.ttTamUng,
    daThu: visit.ttDaThu,
    mienGiam: visit.ttDiscountInv,
    conDu: visit.ttConNo,
  };
  const textSearchDebounce = useDebounce(textSearch.trim(), 300);

  useEffect(() => {
    getCategory();
    updatePageData();
  }, []);

  useEffect(() => {
    handleSearchByFuse(listDichVuSearch, textSearchDebounce ?? '', setListDichVu
  );
  }, [textSearchDebounce]);

  useEffect(() => {
    handleSetPaymentInfor(paymentConfig);
  }, [expenseObject, paymentConfig]);

  useEffect(() => {
    const objFee = handleCaculateFee(values?.orders);
    setExpenseObject({
      tong: objFee?.tong,
      benhNhan: objFee?.benhNhan,
      conNo: objFee?.conNo,
      conDu: objFee?.conDu || '0'
    });
  }, [values?.orders]);

  useEffect(() => {
    if (encounterDiagnosis) {
      setValues({
        ...values,
        encounterDiagnosis
      });
    }
  }, [encounterDiagnosis]);

  const handleDelete = () => {
    setShouldOpenConfirmDialog(true);
  };

  const handleConfirmDelete = () => {
    let newArr = [...(values?.orders || [])];
    if (selectedRowIndex || selectedRowIndex === 0) {
      newArr.splice(selectedRowIndex, 1);
    }
    setFieldValue("orders", newArr);
    setSelectedRow(newArr);
    const objFee = handleCaculateFee(newArr);
    setExpenseObject({
      tong: objFee?.tong,
      benhNhan: objFee?.benhNhan,
      conNo: objFee?.conNo,
      conDu: objFee?.conDu || '0'
    });
    setShouldOpenConfirmDialog(false);
  };

  const handleConvertTreeData = (data: any[]) => {
    let convertedData: any[] = data.map((item, index) => {
      return {
        ...item,
        code: item?.code || item?.name,
        name: item?.name,
        ...(item?.terms &&
          item?.terms?.length && {
            filter: handleConvertTreeData(item?.terms || []),
          }),
      };
    });
    return convertedData;
  };

  const handleChangeEncounterDiagnosis = (name: string, value: any) => {
    setFieldValue("encounterDiagnosis", {
      ...values.encounterDiagnosis,
      [name]: value,
    });
  };

  const handleFilterListDichVu = (classId: any, listDichVuFull: any) => {
    let listDichVuFiltered = listDichVuFull.filter((itemDichVu: any) => itemDichVu?.classId === classId)
    return listDichVuFiltered
  }
  
  const updatePageData = async () => {
    try {
      let termClassId = 0;
      if (isSuaPhieu) {
        let responsePhieu = await getThongTinPhieuChiDinh({
          orderId, 
          orderGroupId
        });
        termClassId = responsePhieu?.data?.data?.termClassId || 0;
        let orders =
			responsePhieu?.data?.data?.orderTermResDtos?.map((item: any) => ({
				...(item?.term || {}),
				visitObjectType:
          item?.objectTypeId || item?.objectTypeCode
            ? {
              code: item?.objectTypeCode,
              name: item?.objectTypeName,
            }
            : {
              code: visit?.visitObjectTypeCode,
              name: visit?.visitObjectTypeName,
            },
        fulfillDeptCode: item?.fulfillDeptCode,
        fulfillDeptName: item?.fulfillDeptName,
        samplingDeptCode: item?.samplingDeptCode,
        samplingDeptName: item?.samplingDeptName,
        notes: item?.notes,
        isOwnExpenses: item?.isOwnExpenses,
        obs: item?.obs
			})) || [];
        setValues({
          ...values,
          encounterDiagnosis: {
            ...values.encounterDiagnosis,
            ...responsePhieu?.data?.data?.encounterDiagnosis
          },
          orders,
          indicationTime: responsePhieu?.data?.data?.indicationTime
        });
        handleSelectService(orders);
        setSelectedRow(orders);
      } else {
        handleGetThongTinChanDoan();
      };
      const responseDichVuChiDinh = await getListDichVu(termClassId);
      const dvKhamBenh = {
        ...responseDichVuChiDinh?.[0] ?? {},
        terms: responseDichVuChiDinh?.[0]?.terms?.map((item: any) => ({
          ...item,
          ...(item?.subs &&
            item?.subs?.length && {
            subs: item?.subs?.filter((itemSub: any) => !itemSub?.attributes?.orderSetCode),
          }),
        }))
      };
      const listDichVuChiDinh = isSuaPhieu
			? responseDichVuChiDinh
			: [dvKhamBenh, ...responseDichVuChiDinh?.slice(1)];
      setListResponseService(listDichVuChiDinh);   
      initTreeData(listDichVuChiDinh, termClassId);
      initTableSelectData(listDichVuChiDinh, termClassId);
      setListDichVuSearch(
        listDichVuChiDinh.flatMap((items: any) => items?.terms.flatMap((item: any) => item?.subs))
      );
    } catch (e) {
      console.error(e);
    }
  };

  const handleGetThongTinChanDoan = async () => {
    try {
      const { data } = await getThongTinChanDoan(visit?.id);
      if (data?.code === CODE.SUCCESS) {
        setValues({
          ...values,
          encounterDiagnosis: {
            ...values.encounterDiagnosis,
            provisionalDiagnosis: data?.data?.provisionalDiagnosis || "",
            provisionalDiagnosisName: data?.data?.provisionalDiagnosisName || "",
            comorbidity: data?.data?.comorbidity || "",
            diagnosisNonCoded:  data?.data?.diagnosisNonCoded || "",
          },
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleGetSelectedItem = (data: any) => {
    if (data) {
      setListDichVu(data?.subs || []);
      setListDichVuSearch(data?.subs || []);
      setTextSearch("");
    } else {
      //Khi click lần 2 vào loại dịch vụ đó thì set ds dịch vụ về full dịch vụ
      setListDichVu(
        listResponseService.flatMap((items: any) =>
          items?.terms.flatMap((item: any) => item?.subs)
        )
      );
      setListDichVuSearch(listResponseService.flatMap((items: any) =>
        items?.terms.flatMap((item: any) => item?.subs)
      ));
    }
  };

  const handleRenderCell = (columnData: any, dataKey: string, rowData: any) => {
    const svcPrice = rowData?.attributes?.[getObjectPriceFieldConfig(typeObjectCode)] ?? 0;
    rowData = {
      ...rowData,
      svcFee: formatMoney(rowData?.attributes?.svcFee) || 0,
      svcFeeHospital: formatMoney(rowData?.attributes?.svcFeeHospital) || 0,
      svcFeeIns: formatMoney(rowData?.attributes?.svcFeeIns) || 0,
      svcQuantity: rowData?.attributes?.svcQuantity || 1,
      svcPrice: formatMoney(svcPrice),
      deptLaboratoryName: rowData?.attributes?.deptLaboratoryName,
    };
    if (typeof rowData.get === "function") {
      return rowData.get(dataKey);
    } else {
      return rowData[dataKey];
    }
  };

  const handleCaculateFee = (data: any) => {
    // Lấy giá trị từ visit ban đầu
    const visitTongChiPhi = visit.ttTong || 0;
    const visitBenhNhan = visit.ttNguoiBenh || 0;
    const visitConNo = visit.ttConNo || 0;
    const visitConDu = visit.ttConDu || 0;

    // Tính tổng tiền dịch vụ vừa kê thêm
    let tongDichVuMoi = 0;
    data?.forEach((item: any) => {
      const unitPrice = item?.attributes?.[getObjectPriceFieldConfig(item?.visitObjectType?.code)] ?? 0;
      const quantity = item?.attributes?.svcQuantity ?? 1;
      const price = unitPrice * quantity;
      tongDichVuMoi += Number(price);
    });

    // Tính còn nợ/còn dư theo logic mới
    let conNo = 0;
    let conDu = 0;

    // 1. Nếu visit có còn nợ > 0 → cộng thêm tiền dịch vụ vừa kê
    if (visitConNo > 0) {
      conNo = visitConNo + tongDichVuMoi;
      conDu = 0;
    }
    // 2. Nếu visit có còn dư > 0 → trừ đi tiền dịch vụ vừa kê
    else if (visitConDu > 0) {
      const result = visitConDu - tongDichVuMoi;
      if (result > 0) {
        // Vẫn còn dư
        conNo = 0;
        conDu = result;
      } else {
        // Chuyển sang còn nợ
        conNo = Math.abs(result);
        conDu = 0;
      }
    }
    // 3. Không có nợ/dư từ visit → chỉ tính dịch vụ mới
    else {
      if (tongDichVuMoi > 0) {
        conNo = tongDichVuMoi;
        conDu = 0;
      }
    }

    return {
      tong: String(visitTongChiPhi + tongDichVuMoi),
      benhNhan: String(visitBenhNhan + tongDichVuMoi),
      conNo: String(conNo),
      conDu: String(conDu)
    };
  };

  const handleSelectService = (data: any) => {
    let result: any[] = [];

    // Process each selected service
    data?.forEach((item: any) => {
      const serviceWithObjectType = {
        ...item,
        visitObjectType: item?.visitObjectType
          ? item?.visitObjectType
          : {
            code: visit?.visitObjectTypeCode,
            name: visit?.visitObjectTypeName,
          },
      };


      result.push(serviceWithObjectType);
    });

    console.log('handleSelectService - result:', {
      resultCount: result.length,
      sample: result[0],
    });

    setFieldValue("orders", result);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): any => {
    const value = (event.target as HTMLInputElement).value;
    const newValue = value ? `'${value}` : '';
    setTextSearch(newValue);
  };

  const handleOnRowClickCheckbox = (rowData: any) => {
    if(!rowData) return;
    
    let _listData = [...listDichVu];
    _listData[rowData.index].isChecked = true;
    let updatedSelectedRows = [...selectedRow];
    const selectedItem = _listData[rowData.index];

    if (!rowData?.rowData?.isChecked) {
      updatedSelectedRows.push(selectedItem);
    } else {
      updatedSelectedRows = updatedSelectedRows.filter(
        (item: any) => item?.["code"] !== selectedItem?.["code"]
      );
    }

    let result = updatedSelectedRows?.map((item: any) => ({
      ...item,
      visitObjectType: item?.visitObjectType
        ? item?.visitObjectType
        : {
          code: visit?.visitObjectTypeCode,
          name: visit?.visitObjectTypeName,
        },
    })) || [];
    
    setFieldValue("orders", result);
    setListDichVu([..._listData]);
    setSelectedRow(updatedSelectedRows);
  }

  const handleOpenSelectICD10 = () => {
    setShouldOpenModalSelectICD10(true);
  };
  
  const getMauChiDinhParams = () => {
		const ORDER_TYPE = parseInt(ORDER_TYPE_ID.XET_NGHIEM);
		const tableData = (values?.orders || []).map((row: any) => {
      const { subs, ...rowData } = row ?? {};

			return {
				orderType: ORDER_TYPE,
				orderTemplate: JSON.stringify(rowData),
			};
		});

		return {
			orderType: ORDER_TYPE,
			orderTemplate: '',
			lstOrderSetMemebers: tableData,
		};
  };

	const onSelectMauChiDinh = (data: IDonThuocMauRequest) => {
		const tableTemplateValue = data.lstOrderSetMemebers?.map((row: any) => ({
			...JSON.parse(row.orderTemplate),
		}));
    const terms = treeData.filter.map((node: any) => [...node.terms]).flat();
    const visitObjectType = {
      code: visit?.visitObjectTypeCode,
      name: visit?.visitObjectTypeName,
    };
    const tableData: any[] = [];

    tableTemplateValue?.forEach((row) => {
      const parentTerm = terms.find((term: any) => term.id === row.parentId);

      if (parentTerm) {
          const termRow = parentTerm.subs.find((sub: any) => sub.id === row.id);
          const isSelectedService = selectedRow.some((item) => item.id === termRow.id);

          if (termRow && !isSelectedService) {
            tableData.push({
              ...termRow,
              ...row,
              visitObjectType
            })
          }
      }
    });

		setValues({
			...values,
			orders: [
        ...(values.orders ?? []),
        ...tableData
      ],
		});
    setSelectedRow([
      ...selectedRow,
      ...tableData,
    ]);
	};

  const saveDonMauValidation = () => {
		if (!(values.orders || []).length) {
			toast.warn('Chưa có dịch vụ được chỉ định cho mẫu này');
			return false;
		}

    return true;
  };

  const handleChangeICD10 = (data: any) => {
    setFieldValue('encounterDiagnosis', {
      ...values?.encounterDiagnosis,
      ...data,
    });
  };

  const getListDichVu = async (termClassId?: number) => {
    try {
      let termsClassIdDV = generalInfo?.isKhamDoan
        ? TERMS_CLASS_ID_DICH_VU.filter(item => (
          item !== TERM_CLASS_IDS.VAN_CHUYEN &&
          item !== TERM_CLASS_IDS.NGAY_GIUONG_CHUYEN_KHOA
        )).join(',')
        : TERMS_CLASS_ID_DICH_VU.join(',');
      const { data } = await getTermClasses({ classIds: termClassId || termsClassIdDV });

      if (CODE.SUCCESS === data?.code) {
        return data.data;
      }
      return [];
    } catch (error) {
      console.error(error);
      toast.error('Xảy ra lỗi khi lấy danh sách dịch vụ, vui lòng thử lại!');
    }
  };

  const handleSetPaymentInfor = async (paymentConfig: any) => {
    const FORM_FIELD_CONFIG = [
      {
        code: "TONG_CHI_PHI",
        name: "Tổng chi phí",
        value: expenseObject?.tong || 0,
        type: "price",
        color: "text-danger"
      },
      {
        code: "BHYT",
        name: "BHYT",
        value: thongTinChiPhi?.bhyt || 0,
        type: "price",
      },
      {
        code: "NGUON_KHAC",
        name: "Nguồn khác",
        value: 0,
        type: "price",
      },
      {
        code: "BENH_NHAN",
        name: "Bệnh nhân",
        value: expenseObject?.benhNhan || 0,
        type: "price",
      },
      {
        code: "TAM_UNG",
        name: "Tạm ứng",
        value: thongTinChiPhi?.tamUng || 0,
        type: "price",
      },
      {
        code: "DA_THU",
        name: "Đã thu",
        value: thongTinChiPhi?.daThu || 0,
        type: "price",
      },
      {
        code: "MIEN_GIAM",
        name: "Miễn giảm",
        value: thongTinChiPhi?.mienGiam || 0,
        type: "price",
      },
      {
        code: "CON_NO",
        name: Number(expenseObject?.conDu) > 0 ? "Còn dư" : "Còn nợ",
        value: Number(expenseObject?.conDu) > 0 ? Number(expenseObject?.conDu) : Math.abs(Number(expenseObject?.conNo)) || 0,
        type: "price",
      },
    ]
    try {
      if (!paymentConfig) {
        setPaymentItem(FORM_FIELD_CONFIG);
        return;
      }
      
      const newArr: any[] = [];
      paymentConfig.forEach((item: any) => {
        const obj = FORM_FIELD_CONFIG.find((obj: any) => obj?.code === item);
        newArr.push(obj);
      })
      setPaymentItem(newArr);
    } catch (err) {
      console.error(err);
    }
  };
  
  const updateRowData = (rowIndex: number, field: string | null, value: any) => {
    const tableData = [...values.orders];

    const updatedList = tableData.map((row: any, index) => {
      if (index === rowIndex) {
        // If field is null, replace entire row with value
        if (field === null) {
          return value;
        }
        // Otherwise, use normal config edit
        const editedValue = configEditValue(field, value);
        return {
          ...row,
          ...editedValue,
        };
      }
      return row;
    });
    setFieldValue("orders", updatedList);
    setSelectedRow(updatedList);
  };

  const configEditValue = (field: string, value: any) => {
		let fieldValue: Record<string, any> = {
      [field]: value,
    };
    const isInsurance = BAO_HIEM === typeObjectCode;

    switch (field) {
      case 'fulfillDepartment':
        fieldValue = {
          fulfillDeptCode: value?.value,
          fulfillDeptName: value?.name,
        };
        break;
      case 'sampleDepartment':
        fieldValue = {
          samplingDeptCode: value?.value,
          samplingDeptName: value?.name,
        };
        break;
      case "isOwnExpenses":
        if (isInsurance) {
          fieldValue = {
            ...fieldValue,
            visitObjectType: getObjectTypeOption(value ? VIEN_PHI : BAO_HIEM),
          }
        }
        break;

      default:
        fieldValue = {
          [field]: value,
        };
        break;
    }

		return fieldValue;
  };

  const getObjectPriceFieldConfig = (objectTypeValue: any) => {
      const priceConfigField = categoriesRef.current.configPriceObject.find((config) => {
        return config.termObjectTypeCode === objectTypeValue
      })?.termAttributeField;

      if (!priceConfigField) return null;

      // eslint-disable-next-line no-new-func
      const calculatePriceFn = new Function('moment', `${priceConfigField}`);
      return calculatePriceFn(moment);
  };

  const getCategory = async () => {
    try {
      const [indexDBData, objectTypeCategory, configPriceObject] = await Promise.all([
        getIndexedDBItem(KEY_DS_DANH_MUC_TIEP_DON),
        getSimpleCategory({
		      type: SIMPLE_CATEGORY_TYPE.DOI_TUONG_DICH_VU,
	      }),
        getObsComplexCategory({
          path: BASE_URL,
          code: OBS_COMPLEX_CATEGORY_CODE.CAU_HINH_GIA_DVKT,
        })
      ]);
      setListICD10(indexDBData?.listICD10 || []);
      categoriesRef.current = {
        objectTypes: objectTypeCategory?.data?.data?.content ?? [],
        configPriceObject: configPriceObject?.data?.content ?? []
      };
    } catch (error) {
      console.error(error);
    }
  };

  const getTermsByClassId = (terms: any[], classId: number) => {
      return terms.find(term => term.terms.some((subTerm: any) => subTerm.classId === classId));
  };

  const initTreeData = (services: any[], termClassId: number) => {
    let listLoaiDichVu = [];

    switch (termClassId) {
      case TERM_CLASS_IDS.XET_NGHIEM:
        listLoaiDichVu.push(getTermsByClassId(services, TERM_CLASS_IDS.XET_NGHIEM));
        break;
      case TERM_CLASS_IDS.CDHA:
        listLoaiDichVu.push(getTermsByClassId(services, TERM_CLASS_IDS.CDHA));
        break;
      case TERM_CLASS_IDS.PTTT:
        listLoaiDichVu.push(getTermsByClassId(services, TERM_CLASS_IDS.PTTT));
        break;
      default:
        listLoaiDichVu = services || [];
        break;
    };

    const treeDataConverted = {
      code: "all",
      name: "Tất cả dịch vụ",
      icon: <IconMenu />,
      filter: handleConvertTreeData(listLoaiDichVu),
    };

    setTreeData(treeDataConverted);
  };

  const initTableSelectData = (services: any[], termClassId: number) => {
    const listDichVuFull = services.flatMap((items: any) =>
        items?.terms.flatMap((item: any) => item?.subs));

    if (!isSuaPhieu) {
      setListDichVu(listDichVuFull);
      return;
    }

    const servicesByClassId = handleFilterListDichVu(termClassId, listDichVuFull);
    setListDichVu(servicesByClassId);
  };

  const getObjectTypeOption = (code: string) => {
    return categoriesRef.current.objectTypes.find((item: any) => item?.code === code);
  };

  const onMenuContextClick = (value: any) => {
    const CONTEXT_MENU_ACTION_MAP = {
      [CONTEXT_MENU_CODE.THONG_TIN_BO_SUNG]: () => setOpenAdditionalInfoModal(true),
    };

    CONTEXT_MENU_ACTION_MAP[value?.code]?.();
    setContextMenu(null);
  };

  const onSaveAdditionalRowData = (editedValue: any) => {
    const tableData = [...values.orders];
    const updatedList = tableData.map((row: any, index) => {
      if (index === rowEditRef.current.index) {
        return {
          ...row,
          obs: editedValue,
        };
      }
      return row;
    });
    setFieldValue("orders", updatedList);
    setSelectedRow(updatedList);
    rowEditRef.current = null;
    setOpenAdditionalInfoModal(false);
  };

  const handleViewSplitItems = (rowData: any) => {
    let mergedRow = rowData;

    // Priority 1: Check if row has stored split items from previous popup save
    if (rowData._hasSplitItems && rowData._splitItems) {
      console.log('handleViewSplitItems - Using stored split items:', {
        splitItems: rowData._splitItems.length,
      });

      mergedRow = {
        ...rowData,
        isMergedRow: true,
        splitGroupId: rowData._splitItems[0]?.splitGroupId,
        splitItems: rowData._splitItems,
        totalQuantity: rowData._splitItems.length,
      };
    }
    // Priority 2: Check if this is already a merged row (has splitItems)
    else if (rowData.isMergedRow && rowData.splitItems) {
      console.log('handleViewSplitItems - Already merged row:', {
        splitItems: rowData.splitItems.length,
      });
    }
    // Priority 3: Regular row with quantity > 1, create split items on the fly
    else {
      const quantity = rowData.attributes?.svcQuantity || 1;

      if (quantity > 1) {
        console.log('handleViewSplitItems - Creating split items for quantity:', quantity);

        // Create split items from this single row
        const splitGroupId = rowData.splitGroupId || ServiceSplitHelper.generateUUID();
        const splitItems = ServiceSplitHelper.createSplitItems(rowData, quantity);

        mergedRow = {
          ...rowData,
          isMergedRow: true,
          splitGroupId,
          splitItems,
          totalQuantity: quantity,
        };
      }
    }
    setSelectedMergedRow(mergedRow);
    setShowSplitModal(true);
  };

  const handleUpdateSplitItems = (updatedItems: SplitServiceItem[]) => {
    const currentOrders = [...(values.orders || [])];
    const splitGroupId = updatedItems[0]?.splitGroupId;
    // Find the original row (the one with this ID, not splitGroupId)
    const originalRowIndex = currentOrders.findIndex(
      (item: any) => item.id === selectedMergedRow?.id
    );

    if (originalRowIndex !== -1) {
      // Update the original row: Keep as 1 row, but store split items in metadata
      const newOrders = [...currentOrders];
      newOrders[originalRowIndex] = {
        ...newOrders[originalRowIndex],
        // Store split items in metadata for later expansion on submit
        _splitItems: updatedItems,
        _hasSplitItems: true,
        attributes: {
          ...newOrders[originalRowIndex].attributes,
          svcQuantity: updatedItems.length, // Update quantity to match split items count
        },
      };
      setFieldValue("orders", newOrders);
      toast.success(`Đã cập nhật ${updatedItems.length} items`);
    }
    setShowSplitModal(false);
    setSelectedMergedRow(null);
  };

  const handleDeleteSplitItem = (itemId: string) => {
    const currentOrders = [...(values.orders || [])];
    const filteredOrders = currentOrders.filter(
      (item: any) => item.id !== itemId
    );

    setFieldValue("orders", filteredOrders);

    // Update selected merged row
    if (selectedMergedRow) {
      const remainingItems = selectedMergedRow.splitItems.filter(
        (item: any) => item.id !== itemId
      );

      if (remainingItems.length === 0) {
        setShowSplitModal(false);
        setSelectedMergedRow(null);
      } else {
        setSelectedMergedRow({
          ...selectedMergedRow,
          splitItems: remainingItems,
          attributes: {
            ...selectedMergedRow.attributes,
            svcQuantity: remainingItems.length,
          },
        });
      }
    }
  };

  const handleAdjustSplitQuantity = (splitGroupId: string, newQuantity: number) => {
    const currentOrders = [...(values.orders || [])];
    const adjustedOrders = ServiceSplitHelper.adjustSplitGroupQuantity(
      currentOrders,
      splitGroupId,
      newQuantity
    );
    setFieldValue("orders", adjustedOrders);
  };
  return (
    <div className="h-100">
      <Modal.Header className="py-3 header-modal">
        <div className="d-flex gap-6">
          <div
            className="d-flex align-items-center gap-3 cursor-pointer"
            onClick={() => handleClose(false)}
          >
            <IconBack />
            <span className="fw-500">Quay lại</span>
          </div>
          <ServiceTemplateButton
							label="Mẫu chỉ định"
							getSaveParams={getMauChiDinhParams}
              orderType={parseInt(ORDER_TYPE_ID.XET_NGHIEM)}
							onSelectMau={onSelectMauChiDinh}
              onSaveValidationFn={saveDonMauValidation}
              multiSelect
              disabled={isSuaPhieu}
						/>
        </div>
        {benhNhanInfo?.thongTinKhamBenh || generalInfo ? (
          <InfoPatientRight benhNhanInfo={benhNhanInfo || generalInfo} />
        ) : (
          <div className="spaces h-65"></div>
        )}
      </Modal.Header>
      <Modal.Body className="py-6 px-0 spaces overflow-hidden spaces h-calc-vh-90">
        <div className="d-flex h-100">
          <div className="spaces width-20 bg-white radius-2 d-flex flex-column">
            <div className="spaces px-12 py-5 h-42">
              <InputSearch
                placeholder="Tìm kiếm"
                handleChange={() => {}}
              />
            </div>
            <SelectTree
              className="w-100 py-2 ps-4 flex-grow-1 border border-top-0 overflow-auto"
              codeCollapses={codeCollapses}
              handleChangeCollapsesCode={setCodeCollapses}
              idSelected={idSelected}
              handleChangeSelectId={setIdSelected}
              getSelectedItem={handleGetSelectedItem}
              selectTree={treeData}
            />
          </div>
          <div className="d-flex flex-column spaces width-80 bg-light radius-2">
            <div className="spaces radius-2 p-10 border-top bg-white">
							<div className="d-flex flex-wrap">
                <div className="spaces W-235 mb-4"> 
                  <DatePickerCustom 
                    label="Ngày y lệnh"
                    name="indicationTime"
                    labelClassName="ms-0 min-w-100px"
                    value={values?.indicationTime ? values?.indicationTime : new Date()}
                    setDateValue={(date) => {
                        setFieldValue("indicationTime", date);
                    }}
                    mode='date-time'
                    disabled={isSuaPhieu}
                    errors={errors?.indicationTime}
                    touched={touched?.indicationTime}
                  />
                </div>
                <div className="spaces d-flex position-relative align-items-start">
                  <Button
                    className="bg-white spaces W-90 py-0 pl-10 mb-3"
                    onClick={handleOpenSelectICD10}
                  >
                    <u className="fw-bold text-pri fs-13px">Chọn bệnh</u>
                  </Button>
                  <LabelRequired label="Chẩn đoán" isRequired className="min-w-90px" />
                </div>
                <Row className="flex-grow-1 position-relative">
                  <ProvisonalDiagnosis
                    encounterDiagnosisValues={values?.encounterDiagnosis}
                    encounterDiagnosisErrors={(errors?.encounterDiagnosis as FormikErrors<any>)}
                    encounterDiagnosisTouched={(touched?.encounterDiagnosis as FormikTouched<any>)}
                    disabled={!isExamined && !generalInfo?.forTiepDon}
                    listComorbidity={listComorbidity}
                    setListComorbidity={setListComorbidity}
                    onChange={handleChangeICD10}
							      handleChangeEncounterDiagnosis={handleChangeEncounterDiagnosis}
                  />
                </Row>
              </div>
              <div className="w-100 d-flex spaces mt-2">
                <div className="flex-grow-1 position-relative">
                  <TextField
                    label="Bệnh kèm theo"
                    className="spaces w-100"
                    inputClassName="w-100 spaces pr-40"
                    name="comorbidity"
                    value={values?.encounterDiagnosis?.comorbidity || ""}
                    onChange={(e: any) =>
                      handleChangeEncounterDiagnosis(e.target.name, e.target.value)
                    }
                    labelClassName="ms-0 min-w-100px"
                  />
                </div>
                <div className="spaces W-310 mb-4 ml-10">
                  <TextField
                    label="BS điều trị"
                    name="bacSiDieuTri"
                    type="text"
                    value={currentUser?.name || ""}
                    labelClassName="ms-0 min-w-85px"
                    disabled
                  />
                </div>
              </div>

              <div className="w-100">
                <TextField
                  className="spaces"
                  inputClassName="w-100"
                  label="Ghi chú"
                  name="notes"
                  value={values?.encounterDiagnosis?.notes || ""}
                  onChange={(e: any) =>
                    handleChangeEncounterDiagnosis(
                      e.target.name,
                      e.target.value
                    )
                  }
                  labelClassName="ms-0 min-w-100 spaces"
                />
              </div>
            </div>
            <div className="spaces flex-grow-1 bg-white px-0 radius-2 mt-6 table-ke-thuoc">
              <div className="d-flex flex-column spaces width-100 bg-light h-100">
                <div className="bg-white">
                  <div className="px-10 py-5 h-35 spaces">
                    <InputSearch
                      placeholder="Tìm kiếm"
                      handleChange={handleChange}
                      className="spaces h-25 pr-4 radius-3"
                    />
                  </div>
                  <div className="min-h-180 spaces bg-white mb-6">
                    <SimpleTable
                      data={listDichVu || []}
                      columns={dsDichVuColumnsSimple}
                      height={180}
                      width={1000}
                      scrollable={true}
                      type={SELECTION_MODE.MULTI_TABLE}
                      setDataChecked={handleSelectService}
                      dataChecked={values?.orders || []}
                      handleRenderCell={handleRenderCell}
                      onRowClick={(rowData: RowMouseEventHandlerParams) => {
                        handleOnRowClickCheckbox(rowData);
                      }}
                      keySearch={textSearchDebounce}
                    />
                  </div>
                </div>
                <div className="d-flex flex-column flex-grow-1 mt-2 bg-white">
                  <div className="d-flex spaces pt-10 pb-6 px-10 text-pri fw-bold">
                    Phiếu chỉ định
                  </div>
                  <div className="flex-grow-1 spaces h-calc-vh-710">
                    <TableCustom
                      columns={DsDichVuChiDinhColumn}
                      data={displayOrders}
                      height={220}
                      tableOptions={{
                        updateRowData,
                        listDoiTuong: categoriesRef.current.objectTypes,
                        setSelectedRow: setSelectedRowIndex,
                        handleDelete,
                        patientInfo: benhNhanInfo?.thongTinKhamBenh || generalInfo,
                        getObjectPriceFieldConfig,
                        adjustSplitQuantity: handleAdjustSplitQuantity,
                        onViewSplitItems: handleViewSplitItems,
                      }}
                      handleContextMenu={(e, row) => {
                        setContextMenu({
                            x: e.clientX,
                            y: e.clientY,
                        });
                        rowEditRef.current = {
                          ...row.original,
                          index: row.index,
                        };
                      }}
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-between spaces px-10 mt-6 bg-white">
                  <PaymentInfor
                    className="flex-1 price-info"
                    paymentData={paymentItem}
                  />
                  <div className="d-flex align-items-center spaces gap-10">
                    <Button
                      type="submit"
                      className="btn-outline min-w-100px"
                      onClick={() => {
                        isSaveAndPrint.current = true;
                      }}
                    >
                      <i className="bi bi-printer" />
                      Lưu và in
                    </Button>
                    <Button className="btn-fill min-w-100px" type="submit">
                      <IconButtonSave /> Lưu
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      
      {shouldOpenConfirmDialog &&
        <ConfirmDialog
          className="z-index-1060"
          show={shouldOpenConfirmDialog}
          title="Thông báo"
          message="Bạn có chắc chắn muốn bỏ dịch vụ này không ?"
          yes="Xác nhận"
          close="Đóng"
          onCloseClick={() => setShouldOpenConfirmDialog(false)}
          onYesClick={() => handleConfirmDelete()}
        />
      }

      <ICD10
        shouldOpenModalICD10={shouldOpenModalICD10}
        setShouldOpenModalICD10={setShouldOpenModalICD10}
        shouldOpenModalSelectICD10={shouldOpenModalSelectICD10}
        setShouldOpenModalSelectICD10={setShouldOpenModalSelectICD10}
        listICD10={listICD10}
        listComorbidity={listComorbidity}
        setListComorbidity={setListComorbidity}
        selectionModeICD10="radio"
        data={values?.encounterDiagnosis}
        onChange={handleChangeICD10}
      />

      {contextMenu && (
        <OctContextMenu
          handleClickOptionContextMenu={onMenuContextClick}
          handleCloseMenu={() => setContextMenu(null)}
          data={SERVICE_CONTEXT_MENU_OPTIONS}
          target={contextMenu}
        />
      )}

      {openAdditionalInfoModal &&
        <GenerateFormModal
          title="Thông tin bổ sung dịch vụ"
          termModel="service-additional-info"
          open={openAdditionalInfoModal}
          onClose={() => setOpenAdditionalInfoModal(false)}
          onSave={onSaveAdditionalRowData}
          itemEdit={rowEditRef.current}
        />
      }

      {showSplitModal && selectedMergedRow && (
        <SplitItemsModal
          show={showSplitModal}
          onClose={() => {
            setShowSplitModal(false);
            setSelectedMergedRow(null);
          }}
          mergedRow={selectedMergedRow}
          onUpdateItems={handleUpdateSplitItems}
          categoriesRef={categoriesRef}
          getObjectPriceFieldConfig={getObjectPriceFieldConfig}
          patientInfo={benhNhanInfo?.thongTinKhamBenh || generalInfo}
        />
      )}
    </div>
  );
};

export default FormChiDinhDichVu;
